export const FETCH_LOAD_ALL_DELETED_USER_LISR_REQUEST = 'FETCH_LOAD_ALL_DELETED_USER_LISR_REQUEST'
export const FETCH_LOAD_ALL_DELETED_USER_LISR_SUCCESS = 'FETCH_LOAD_ALL_DELETED_USER_LISR_SUCCESS'
export const FETCH_LOAD_ALL_DELETED_USER_LISR_FALUIRE = 'FETCH_LOAD_ALL_DELETED_USER_LISR_FALUIRE'
export const SEARCH_DELETED_USERS = 'SEARCH_DELETED_USERS'
